import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CostReceiverTypeService } from '../proxy/controlling/controllers/cost-receiver-type.service';

FieldBuilder.setNamespace('Controlling');

export const COSTRECEIVER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CostReceiver.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.CostReceiver.IsActive')
    .build(),
  FieldBuilder
    .number('cycle', 'Entity.CostReceiver.Cycle')
    .build(),
  FieldBuilder
    .number('cycleRotation', 'Entity.CostReceiver.CycleRotation')
    .build(),
  FieldBuilder
    .foreignKey('costReceiverTypeId', 'Entity.CostReceiverType', CostReceiverTypeService)
    .required()
    .displayFromNested('costReceiverType.name')
    .sortBy('costReceiverType.name')
    .build(),
];

export const COSTRECEIVER_CONFIG = {
  entityName: 'CostReceiver',
  localizationKey: 'Controlling::Entity.CostReceiver',
  fields: COSTRECEIVER_FIELDS,
  permission: 'ControllingLiquidations.CostReceivers',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
